import { NavLink } from "hooks/useCustomNavigation";
import "./index.scss";
import { INTERNAL_PATHS } from "routes/paths";
import { DSButton } from "components/UI/atoms";

export const CategoriesList = ({ categories = [] }) => {
  return (
    <ul className="categories-list">
      {categories.map((item) => (
        <li key={item.slug}>
          <NavLink
            to={`${INTERNAL_PATHS.BUY_GIFT_CARDS}?category=${item.slug}`}
          >
            <DSButton
              variant="ghost"
              size="xsmall"
              customClassName="categories-item"
            >
              {item.name}
            </DSButton>
          </NavLink>
        </li>
      ))}
      <li>
        <NavLink to={INTERNAL_PATHS.BUY_GIFT_CARDS}>
          <DSButton
            variant="ghost"
            size="small"
            customClassName="categories-item see-all-categories"
          >
            See All Brands
          </DSButton>
        </NavLink>
      </li>
    </ul>
  );
};
